import { observable } from 'mobx';
import { noop } from '@src/utils/common-util';
import BaseModalStore from '@src/components/modal-container/base-modal-store';

class ReservationSuccessModalStore extends BaseModalStore {
  @observable account = '';
  @observable serverName = '新服名称';
  @observable friends = [];
  closeCallback = noop;

  constructor(options = {}) {
    super(options);
    Object.assign(this, options);
  }

  setResult({ account, serverName, friends } = {}) {
    this.account = account || '';
    this.serverName = serverName || '新服名称';
    this.friends = Array.isArray(friends) ? friends.filter(Boolean).slice(0, 3) : [];
  }

  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.closeCallback();
    this.clearStyle();
  };
}

export default ReservationSuccessModalStore;
